import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_the_informations = _resolveComponent("the-informations")!
  const _component_the_dialog_error = _resolveComponent("the-dialog-error")!
  const _component_the_loader_full_page = _resolveComponent("the-loader-full-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_the_informations),
    (_ctx.isErrorToDisplay)
      ? (_openBlock(), _createBlock(_component_the_dialog_error, {
          key: 0,
          onDialogclosevalid: _ctx.hideDialogError
        }, null, 8, ["onDialogclosevalid"]))
      : _createCommentVNode("", true),
    (_ctx.loadingInProgress)
      ? (_openBlock(), _createBlock(_component_the_loader_full_page, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}